"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgForward(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 0 14 24", fill: "none" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.595 12l-5.07-5-1.448 1.429 2.594 2.561H6.305v2.02h8.366l-2.594 2.561L13.525 17l5.07-5z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Forward')(SvgForward);
//# sourceMappingURL=Forward.js.map